const dictionaryRoutes = [
  {
    path: 'app/:code',
    name: 'app',
    meta: {
      title: '双向转诊',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/app/two-way-referral.vue'], resolve)
  }
  /*
  * /course-of-disease-web/app/two-way-referral/apply
  * /course-of-disease-web/app/two-way-referral/access
  * /course-of-disease-web/app/two-way-referral/manage
  *
  * app/L2NvdXJzZS1vZi1kaXNlYXNlLXdlYi9hcHAvdHdvLXdheS1yZWZlcnJhbC9hcHBseQ
  * app/L2NvdXJzZS1vZi1kaXNlYXNlLXdlYi9hcHAvdHdvLXdheS1yZWZlcnJhbC9hY2Nlc3M
  * app/L2NvdXJzZS1vZi1kaXNlYXNlLXdlYi9hcHAvdHdvLXdheS1yZWZlcnJhbC9tYW5hZ2U
  */
]

export default dictionaryRoutes
